import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ManagedUsersListRowInterface } from '../../../core/models/managed-user.model';
import { ListActionsBaseComponent } from '../../../orders/shared/list-components/list-actions-base/list-actions-base.component';
import { ClickStopPropagationDirective } from '../../../shared/directives/click-stop-propagation/click-stop-propagation.directive';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-managed-users-list-actions',
  standalone: true,
  imports: [SharedModule, ClickStopPropagationDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './managed-users-list-actions.component.html',
})
export class ManagedUsersListActionsComponent extends ListActionsBaseComponent {
  @Input() row: ManagedUsersListRowInterface;

  @Output() resendPassword = new EventEmitter<number>();
  @Output() blockUser = new EventEmitter<number>();
  @Output() unblockUser = new EventEmitter<number>();

  onResendPasswordLink(userId: number): void {
    this.resendPassword.emit(userId);
  }

  onBlockUser(): void {
    this.blockUser.emit(this.row.id);
  }

  onUnblockUser(): void {
    this.unblockUser.emit(this.row.id);
  }
}
